import type { CompanyDto } from '../../shared/companies/models/company.models';
import { COMPANY_ALL_ID } from '../../shared/companies/models/company.models';

export const MOCK_COMPANY_ALL: CompanyDto = { id: COMPANY_ALL_ID, name: 'All' };

export const MOCK_COMPANIES: CompanyDto[] = [
  MOCK_COMPANY_ALL,
  { id: '20000000-0000-4000-8000-000000000001', name: 'ZHK' },
  { id: '20000000-0000-4000-8000-000000000002', name: 'ZCH' },
  { id: '20000000-0000-4000-8000-000000000003', name: 'ZUK' },
  { id: '20000000-0000-4000-8000-000000000004', name: 'ZSG' },
  { id: '20000000-0000-4000-8000-000000000005', name: 'ZAT' },
  { id: '20000000-0000-4000-8000-000000000006', name: 'ZDE' },
];

export function mockHandleCompaniesRoute(
  method: string,
  canonicalPath: string,
  requestUrl: string,
): { status: number; body: unknown } | null {
  if (method !== 'GET' || canonicalPath !== '/api/companies') {
    return null;
  }

  const includeAll = new URL(requestUrl, 'http://mock').searchParams.get('includeAll') === 'true';
  const companies = includeAll
    ? MOCK_COMPANIES
    : MOCK_COMPANIES.filter((row) => row.id !== COMPANY_ALL_ID);

  return { status: 200, body: companies };
}
